module.exports = __webpack_public_path__ + "img/background-panel-hello.088018a0.svg";